import PropTypes from "prop-types"

import queryIcon from "images/icons/icon-new-connection-query.svg"

import "./learn_more_button.scss"

const LearnMoreButton = ({ darkHeader, location, title, url }) => {
  const extraStyle = darkHeader ? "dark-header" : ""

  return (
    <a
      styleName={`learn-more ${extraStyle}`}
      className="learn-more-icon"
      title={title}
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_blank"
      data-track-ifttt-next-event="click"
      data-track-data={JSON.stringify({
        object_type: "info_button",
        location_type: location,
      })}
      href={url}
      rel="noreferrer"
    >
      <span
        dangerouslySetInnerHTML={{
          __html: queryIcon,
        }}
      />
    </a>
  )
}

LearnMoreButton.propTypes = {
  darkHeader: PropTypes.bool,
  location: PropTypes.string.isRequired,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
}

LearnMoreButton.defaultProps = {
  darkHeader: false,
  title: "Learn more",
}

export default LearnMoreButton
